"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var colorBgPopup = _a.colorBgPopup,
      depth2 = _a.depth2,
      sizeBorderRadiusPaper = _a.sizeBorderRadiusPaper,
      sizeBorderRadius = _a.sizeBorderRadius;
  return {
    base: {
      background: colorBgPopup.normal,
      boxShadow: depth2,
      borderRadius: sizeBorderRadius
    },
    dropdown: {
      borderRadius: sizeBorderRadiusPaper,
      overflow: 'hidden'
    },
    tooltip: {
      borderRadius: sizeBorderRadius
    }
  };
};